import _slicedToArray from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { Item as $23896c8062ba3967$re_export$Item, Section as $23896c8062ba3967$re_export$Section } from "@react-stately/collections";
import $3toCD$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $3toCD$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import { useSlotProps as $3toCD$useSlotProps, useDOMRef as $3toCD$useDOMRef, useUnwrapDOMRef as $3toCD$useUnwrapDOMRef, useIsMobileDevice as $3toCD$useIsMobileDevice, dimensionValue as $3toCD$dimensionValue, classNames as $3toCD$classNames, SlotProvider as $3toCD$SlotProvider } from "@react-spectrum/utils";
import { Field as $3toCD$Field } from "@react-spectrum/label";
import { FieldButton as $3toCD$FieldButton } from "@react-spectrum/button";
import { useSelect as $3toCD$useSelect, HiddenSelect as $3toCD$HiddenSelect } from "@react-aria/select";
import { useListBoxLayout as $3toCD$useListBoxLayout, ListBoxBase as $3toCD$ListBoxBase } from "@react-spectrum/listbox";
import { useResizeObserver as $3toCD$useResizeObserver, useLayoutEffect as $3toCD$useLayoutEffect, mergeProps as $3toCD$mergeProps } from "@react-aria/utils";
import { Tray as $3toCD$Tray, Popover as $3toCD$Popover } from "@react-spectrum/overlays";
import { useHover as $3toCD$useHover, PressResponder as $3toCD$PressResponder } from "@react-aria/interactions";
import { ProgressCircle as $3toCD$ProgressCircle } from "@react-spectrum/progress";
import $3toCD$react, { useRef as $3toCD$useRef, useState as $3toCD$useState, useCallback as $3toCD$useCallback } from "react";
import { Text as $3toCD$Text } from "@react-spectrum/text";
import { useLocalizedStringFormatter as $3toCD$useLocalizedStringFormatter } from "@react-aria/i18n";
import { useProviderProps as $3toCD$useProviderProps, useProvider as $3toCD$useProvider } from "@react-spectrum/provider";
import { useSelectState as $3toCD$useSelectState } from "@react-stately/select";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $23df90b22503709f$exports = {};
var $d1a348ee160b1c35$exports = {};
$d1a348ee160b1c35$exports = {
  "loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
  "placeholder": "\u062D\u062F\u062F \u062E\u064A\u0627\u0631\u064B\u0627..."
};
var $6f4b5567d8931b2c$exports = {};
$6f4b5567d8931b2c$exports = {
  "loading": "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435...",
  "placeholder": "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043E\u043F\u0446\u0438\u044F"
};
var $413f5c9b05a53d70$exports = {};
$413f5c9b05a53d70$exports = {
  "loading": "Na\u010D\xEDt\xE1n\xED...",
  "placeholder": "Vyberte vhodnou mo\u017Enost..."
};
var $23214587b45d0c7a$exports = {};
$23214587b45d0c7a$exports = {
  "loading": "Indl\xE6ser ...",
  "placeholder": "V\xE6lg en mulighed ..."
};
var $291e2fb947064c57$exports = {};
$291e2fb947064c57$exports = {
  "loading": "Laden...",
  "placeholder": "Option ausw\xE4hlen..."
};
var $c5247287ce725677$exports = {};
$c5247287ce725677$exports = {
  "loading": "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...",
  "placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5\u2026"
};
var $3d85b21727aef233$exports = {};
$3d85b21727aef233$exports = {
  "placeholder": "Select an option\u2026",
  "loading": "Loading\u2026"
};
var $573c338a19d2e44a$exports = {};
$573c338a19d2e44a$exports = {
  "loading": "Cargando\u2026",
  "placeholder": "Selecciona una de estas opciones..."
};
var $52537a7562a0fcd4$exports = {};
$52537a7562a0fcd4$exports = {
  "loading": "Laadimine...",
  "placeholder": "Valige valikuline..."
};
var $f128a549f8c2b170$exports = {};
$f128a549f8c2b170$exports = {
  "loading": "Ladataan\u2026",
  "placeholder": "Valitse vaihtoehto..."
};
var $f69e7a23857afc72$exports = {};
$f69e7a23857afc72$exports = {
  "loading": "Chargement...",
  "placeholder": "S\xE9lectionnez une option..."
};
var $cf880887f8515ea2$exports = {};
$cf880887f8515ea2$exports = {
  "loading": "\u05D8\u05D5\u05E2\u05DF...",
  "placeholder": "\u05D1\u05D7\u05E8 \u05D0\u05E4\u05E9\u05E8\u05D5\u05EA..."
};
var $1f679bbb79879af2$exports = {};
$1f679bbb79879af2$exports = {
  "loading": "U\u010Ditavam...",
  "placeholder": "Odaberite opciju"
};
var $fc9bc2ec180ca71d$exports = {};
$fc9bc2ec180ca71d$exports = {
  "loading": "Bet\xF6lt\xE9s folyamatban\u2026",
  "placeholder": "V\xE1lasszon egy opci\xF3t\u2026"
};
var $9fbc1ff7e87407ac$exports = {};
$9fbc1ff7e87407ac$exports = {
  "loading": "Caricamento...",
  "placeholder": "Seleziona un\u2019opzione..."
};
var $96673b78dbaf44b6$exports = {};
$96673b78dbaf44b6$exports = {
  "loading": "\u8AAD\u307F\u8FBC\u307F\u4E2D...",
  "placeholder": "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E..."
};
var $beddb5ded972a868$exports = {};
$beddb5ded972a868$exports = {
  "loading": "\uB85C\uB4DC \uC911",
  "placeholder": "\uC120\uD0DD \uC0AC\uD56D \uC120\uD0DD"
};
var $2ac19a654f19cde2$exports = {};
$2ac19a654f19cde2$exports = {
  "loading": "\u012Ekeliama...",
  "placeholder": "Pasirinkite parinkt\u012F..."
};
var $844be78af2d57459$exports = {};
$844be78af2d57459$exports = {
  "loading": "Notiek iel\u0101de...",
  "placeholder": "Atlasiet opciju..."
};
var $42b05097f4e27f73$exports = {};
$42b05097f4e27f73$exports = {
  "loading": "Laster inn ...",
  "placeholder": "Velg et alternativ..."
};
var $74dd3f417665b06f$exports = {};
$74dd3f417665b06f$exports = {
  "loading": "Laden...",
  "placeholder": "Optie selecteren..."
};
var $6221651ca0306be3$exports = {};
$6221651ca0306be3$exports = {
  "loading": "\u0141adowanie...",
  "placeholder": "Wybierz opcj\u0119..."
};
var $45bd58553e21ec53$exports = {};
$45bd58553e21ec53$exports = {
  "loading": "Carregando...",
  "placeholder": "Selecione uma op\xE7\xE3o..."
};
var $7ae7985d84009e3a$exports = {};
$7ae7985d84009e3a$exports = {
  "loading": "A carregar...",
  "placeholder": "Selecionar uma op\xE7\xE3o..."
};
var $c83f9725f6024f47$exports = {};
$c83f9725f6024f47$exports = {
  "loading": "Se \xEEncarc\u0103...",
  "placeholder": "Selecta\u021Bi o op\u021Biune"
};
var $0fb522ae7b51fefd$exports = {};
$0fb522ae7b51fefd$exports = {
  "loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
  "placeholder": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440..."
};
var $5ca94db2a021a726$exports = {};
$5ca94db2a021a726$exports = {
  "loading": "Na\u010D\xEDtava sa...",
  "placeholder": "Vyberte mo\u017Enos\u0165..."
};
var $2c7a753ed24e9851$exports = {};
$2c7a753ed24e9851$exports = {
  "loading": "Nalaganje...",
  "placeholder": "Izberite mo\u017Enost"
};
var $14a1d1750c9de591$exports = {};
$14a1d1750c9de591$exports = {
  "loading": "U\u010Ditavam...",
  "placeholder": "Izaberite opciju"
};
var $bf3f89a84488b301$exports = {};
$bf3f89a84488b301$exports = {
  "loading": "L\xE4ser in...",
  "placeholder": "V\xE4lj ett alternativ..."
};
var $1ff90abddf42fc72$exports = {};
$1ff90abddf42fc72$exports = {
  "loading": "Y\xFCkleniyor...",
  "placeholder": "Bir se\xE7im yap\u0131n\u2026"
};
var $4f07d8c17926a679$exports = {};
$4f07d8c17926a679$exports = {
  "loading": "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
  "placeholder": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u043F\u0446\u0456\u044E..."
};
var $07a8d3b903fa886f$exports = {};
$07a8d3b903fa886f$exports = {
  "loading": "\u6B63\u5728\u52A0\u8F7D...",
  "placeholder": "\u9009\u62E9\u4E00\u4E2A\u9009\u9879..."
};
var $e1416a5539091e36$exports = {};
$e1416a5539091e36$exports = {
  "loading": "\u6B63\u5728\u8F09\u5165",
  "placeholder": "\u9078\u53D6\u4E00\u500B\u9078\u9805"
};
$23df90b22503709f$exports = {
  "ar-AE": $d1a348ee160b1c35$exports,
  "bg-BG": $6f4b5567d8931b2c$exports,
  "cs-CZ": $413f5c9b05a53d70$exports,
  "da-DK": $23214587b45d0c7a$exports,
  "de-DE": $291e2fb947064c57$exports,
  "el-GR": $c5247287ce725677$exports,
  "en-US": $3d85b21727aef233$exports,
  "es-ES": $573c338a19d2e44a$exports,
  "et-EE": $52537a7562a0fcd4$exports,
  "fi-FI": $f128a549f8c2b170$exports,
  "fr-FR": $f69e7a23857afc72$exports,
  "he-IL": $cf880887f8515ea2$exports,
  "hr-HR": $1f679bbb79879af2$exports,
  "hu-HU": $fc9bc2ec180ca71d$exports,
  "it-IT": $9fbc1ff7e87407ac$exports,
  "ja-JP": $96673b78dbaf44b6$exports,
  "ko-KR": $beddb5ded972a868$exports,
  "lt-LT": $2ac19a654f19cde2$exports,
  "lv-LV": $844be78af2d57459$exports,
  "nb-NO": $42b05097f4e27f73$exports,
  "nl-NL": $74dd3f417665b06f$exports,
  "pl-PL": $6221651ca0306be3$exports,
  "pt-BR": $45bd58553e21ec53$exports,
  "pt-PT": $7ae7985d84009e3a$exports,
  "ro-RO": $c83f9725f6024f47$exports,
  "ru-RU": $0fb522ae7b51fefd$exports,
  "sk-SK": $5ca94db2a021a726$exports,
  "sl-SI": $2c7a753ed24e9851$exports,
  "sr-SP": $14a1d1750c9de591$exports,
  "sv-SE": $bf3f89a84488b301$exports,
  "tr-TR": $1ff90abddf42fc72$exports,
  "uk-UA": $4f07d8c17926a679$exports,
  "zh-CN": $07a8d3b903fa886f$exports,
  "zh-TW": $e1416a5539091e36$exports
};
var $3c14925a8a65017e$exports = {};
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown", function () {
  return $3c14925a8a65017e$export$f33c6833ddc773bd;
}, function (v) {
  return $3c14925a8a65017e$export$f33c6833ddc773bd = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-chevron", function () {
  return $3c14925a8a65017e$export$abbb0cf96dbbb8a0;
}, function (v) {
  return $3c14925a8a65017e$export$abbb0cf96dbbb8a0 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-trigger", function () {
  return $3c14925a8a65017e$export$37a6d27a7cb47ce5;
}, function (v) {
  return $3c14925a8a65017e$export$37a6d27a7cb47ce5 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-label", function () {
  return $3c14925a8a65017e$export$1235a00795b885e7;
}, function (v) {
  return $3c14925a8a65017e$export$1235a00795b885e7 = v;
});
$parcel$export($3c14925a8a65017e$exports, "is-placeholder", function () {
  return $3c14925a8a65017e$export$e5b2f5233e4e5194;
}, function (v) {
  return $3c14925a8a65017e$export$e5b2f5233e4e5194 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Icon", function () {
  return $3c14925a8a65017e$export$d374b04f30360026;
}, function (v) {
  return $3c14925a8a65017e$export$d374b04f30360026 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-invalidIcon", function () {
  return $3c14925a8a65017e$export$a32fdb5a063ea755;
}, function (v) {
  return $3c14925a8a65017e$export$a32fdb5a063ea755 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-progressCircle", function () {
  return $3c14925a8a65017e$export$18281c34cabbd13f;
}, function (v) {
  return $3c14925a8a65017e$export$18281c34cabbd13f = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown--quiet", function () {
  return $3c14925a8a65017e$export$b2306417a70c7a62;
}, function (v) {
  return $3c14925a8a65017e$export$b2306417a70c7a62 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-popover--quiet", function () {
  return $3c14925a8a65017e$export$cbeaf986973c0633;
}, function (v) {
  return $3c14925a8a65017e$export$cbeaf986973c0633 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Field", function () {
  return $3c14925a8a65017e$export$f6d480ae1e56eba0;
}, function (v) {
  return $3c14925a8a65017e$export$f6d480ae1e56eba0 = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-fieldWrapper--quiet", function () {
  return $3c14925a8a65017e$export$66ddc2410b0e9eba;
}, function (v) {
  return $3c14925a8a65017e$export$66ddc2410b0e9eba = v;
});
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-fieldWrapper--positionSide", function () {
  return $3c14925a8a65017e$export$c0b4e9596538c7b1;
}, function (v) {
  return $3c14925a8a65017e$export$c0b4e9596538c7b1 = v;
});
$parcel$export($3c14925a8a65017e$exports, "is-selected", function () {
  return $3c14925a8a65017e$export$1e0fb04f31d3c22a;
}, function (v) {
  return $3c14925a8a65017e$export$1e0fb04f31d3c22a = v;
});
$parcel$export($3c14925a8a65017e$exports, "is-invalid", function () {
  return $3c14925a8a65017e$export$14a30de2866685fa;
}, function (v) {
  return $3c14925a8a65017e$export$14a30de2866685fa = v;
});
$parcel$export($3c14925a8a65017e$exports, "is-disabled", function () {
  return $3c14925a8a65017e$export$d35bc1e505d1ebbf;
}, function (v) {
  return $3c14925a8a65017e$export$d35bc1e505d1ebbf = v;
});
$parcel$export($3c14925a8a65017e$exports, "is-hovered", function () {
  return $3c14925a8a65017e$export$b8813cd5d7824ce7;
}, function (v) {
  return $3c14925a8a65017e$export$b8813cd5d7824ce7 = v;
});
$parcel$export($3c14925a8a65017e$exports, "focus-ring", function () {
  return $3c14925a8a65017e$export$f39a09f249340e2a;
}, function (v) {
  return $3c14925a8a65017e$export$f39a09f249340e2a = v;
});
var $3c14925a8a65017e$export$f33c6833ddc773bd;
var $3c14925a8a65017e$export$abbb0cf96dbbb8a0;
var $3c14925a8a65017e$export$37a6d27a7cb47ce5;
var $3c14925a8a65017e$export$1235a00795b885e7;
var $3c14925a8a65017e$export$e5b2f5233e4e5194;
var $3c14925a8a65017e$export$d374b04f30360026;
var $3c14925a8a65017e$export$a32fdb5a063ea755;
var $3c14925a8a65017e$export$18281c34cabbd13f;
var $3c14925a8a65017e$export$b2306417a70c7a62;
var $3c14925a8a65017e$export$cbeaf986973c0633;
var $3c14925a8a65017e$export$f6d480ae1e56eba0;
var $3c14925a8a65017e$export$66ddc2410b0e9eba;
var $3c14925a8a65017e$export$c0b4e9596538c7b1;
var $3c14925a8a65017e$export$1e0fb04f31d3c22a;
var $3c14925a8a65017e$export$14a30de2866685fa;
var $3c14925a8a65017e$export$d35bc1e505d1ebbf;
var $3c14925a8a65017e$export$b8813cd5d7824ce7;
var $3c14925a8a65017e$export$f39a09f249340e2a;
$3c14925a8a65017e$export$f33c6833ddc773bd = "spectrum-Dropdown_6d8ec0";
$3c14925a8a65017e$export$abbb0cf96dbbb8a0 = "spectrum-Dropdown-chevron_6d8ec0";
$3c14925a8a65017e$export$37a6d27a7cb47ce5 = "spectrum-Dropdown-trigger_6d8ec0";
$3c14925a8a65017e$export$1235a00795b885e7 = "spectrum-Dropdown-label_6d8ec0";
$3c14925a8a65017e$export$e5b2f5233e4e5194 = "is-placeholder_6d8ec0";
$3c14925a8a65017e$export$d374b04f30360026 = "spectrum-Icon_6d8ec0";
$3c14925a8a65017e$export$a32fdb5a063ea755 = "spectrum-Dropdown-invalidIcon_6d8ec0";
$3c14925a8a65017e$export$18281c34cabbd13f = "spectrum-Dropdown-progressCircle_6d8ec0";
$3c14925a8a65017e$export$b2306417a70c7a62 = "spectrum-Dropdown--quiet_6d8ec0";
$3c14925a8a65017e$export$cbeaf986973c0633 = "spectrum-Dropdown-popover--quiet_6d8ec0";
$3c14925a8a65017e$export$f6d480ae1e56eba0 = "spectrum-Field_6d8ec0";
$3c14925a8a65017e$export$66ddc2410b0e9eba = "spectrum-Dropdown-fieldWrapper--quiet_6d8ec0";
$3c14925a8a65017e$export$c0b4e9596538c7b1 = "spectrum-Dropdown-fieldWrapper--positionSide_6d8ec0";
$3c14925a8a65017e$export$1e0fb04f31d3c22a = "is-selected_6d8ec0";
$3c14925a8a65017e$export$14a30de2866685fa = "is-invalid_6d8ec0";
$3c14925a8a65017e$export$d35bc1e505d1ebbf = "is-disabled_6d8ec0";
$3c14925a8a65017e$export$b8813cd5d7824ce7 = "is-hovered_6d8ec0";
$3c14925a8a65017e$export$f39a09f249340e2a = "focus-ring_6d8ec0";
function $51664a9007a3c6f9$var$Picker(props, ref) {
  props = $3toCD$useSlotProps(props, 'picker');
  props = $3toCD$useProviderProps(props);
  var stringFormatter = $3toCD$useLocalizedStringFormatter( /*@__PURE__*/$parcel$interopDefault($23df90b22503709f$exports));
  var _props = props,
    autoComplete = _props.autoComplete,
    isDisabled = _props.isDisabled,
    _props$direction = _props.direction,
    direction = _props$direction === void 0 ? 'bottom' : _props$direction,
    _props$align = _props.align,
    align = _props$align === void 0 ? 'start' : _props$align,
    _props$shouldFlip = _props.shouldFlip,
    shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip,
    _props$placeholder = _props.placeholder,
    placeholder = _props$placeholder === void 0 ? stringFormatter.format('placeholder') : _props$placeholder,
    validationState = _props.validationState,
    isQuiet = _props.isQuiet,
    label = _props.label,
    _props$labelPosition = _props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'top' : _props$labelPosition,
    menuWidth = _props.menuWidth,
    name = _props.name,
    autoFocus = _props.autoFocus;
  var state = $3toCD$useSelectState(props);
  var domRef = $3toCD$useDOMRef(ref);
  var popoverRef = $3toCD$useRef();
  var triggerRef = $3toCD$useRef();
  var unwrappedTriggerRef = $3toCD$useUnwrapDOMRef(triggerRef);
  var listboxRef = $3toCD$useRef();
  // We create the listbox layout in Picker and pass it to ListBoxBase below
  // so that the layout information can be cached even while the listbox is not mounted.
  // We also use the layout as the keyboard delegate for type to select.
  var layout = $3toCD$useListBoxLayout(state);
  var _$3toCD$useSelect = $3toCD$useSelect(_objectSpread(_objectSpread({}, props), {}, {
      keyboardDelegate: layout
    }), state, unwrappedTriggerRef),
    labelProps = _$3toCD$useSelect.labelProps,
    triggerProps = _$3toCD$useSelect.triggerProps,
    valueProps = _$3toCD$useSelect.valueProps,
    menuProps = _$3toCD$useSelect.menuProps,
    descriptionProps = _$3toCD$useSelect.descriptionProps,
    errorMessageProps = _$3toCD$useSelect.errorMessageProps;
  var isMobile = $3toCD$useIsMobileDevice();
  var _$3toCD$useHover = $3toCD$useHover({
      isDisabled: isDisabled
    }),
    hoverProps = _$3toCD$useHover.hoverProps,
    isHovered = _$3toCD$useHover.isHovered;
  var isLoadingInitial = props.isLoading && state.collection.size === 0;
  var isLoadingMore = props.isLoading && state.collection.size > 0;
  // On small screen devices, the listbox is rendered in a tray, otherwise a popover.
  var listbox = /*#__PURE__*/$3toCD$react.createElement($3toCD$ListBoxBase, _objectSpread(_objectSpread({}, menuProps), {}, {
    ref: listboxRef,
    disallowEmptySelection: true,
    autoFocus: state.focusStrategy || true,
    shouldSelectOnPressUp: true,
    focusOnPointerEnter: true,
    layout: layout,
    state: state,
    width: isMobile ? '100%' : undefined,
    // Set max height: inherit so Tray scrolling works
    UNSAFE_style: {
      maxHeight: 'inherit'
    },
    isLoading: isLoadingMore,
    onLoadMore: props.onLoadMore
  }));
  // Measure the width of the button to inform the width of the menu (below).
  var _$3toCD$useState = $3toCD$useState(null),
    _$3toCD$useState2 = _slicedToArray(_$3toCD$useState, 2),
    buttonWidth = _$3toCD$useState2[0],
    setButtonWidth = _$3toCD$useState2[1];
  var _$3toCD$useProvider = $3toCD$useProvider(),
    scale = _$3toCD$useProvider.scale;
  var onResize = $3toCD$useCallback(function () {
    if (!isMobile && unwrappedTriggerRef.current) {
      var width = unwrappedTriggerRef.current.offsetWidth;
      setButtonWidth(width);
    }
  }, [unwrappedTriggerRef, setButtonWidth, isMobile]);
  $3toCD$useResizeObserver({
    ref: unwrappedTriggerRef,
    onResize: onResize
  });
  $3toCD$useLayoutEffect(onResize, [scale, state.selectedKey, onResize]);
  var overlay;
  if (isMobile) overlay = /*#__PURE__*/$3toCD$react.createElement($3toCD$Tray, {
    state: state
  }, listbox);else {
    // If quiet, use the default width, otherwise match the width of the button. This can be overridden by the menuWidth prop.
    // Always have a minimum width of the button width. When quiet, there is an extra offset to add.
    // Not using style props for this because they don't support `calc`.
    var width = isQuiet ? null : buttonWidth;
    var style = {
      width: menuWidth ? $3toCD$dimensionValue(menuWidth) : width,
      minWidth: isQuiet ? "calc(".concat(buttonWidth, "px + calc(2 * var(--spectrum-dropdown-quiet-offset)))") : buttonWidth
    };
    overlay = /*#__PURE__*/$3toCD$react.createElement($3toCD$Popover, {
      UNSAFE_style: style,
      UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown-popover', {
        'spectrum-Dropdown-popover--quiet': isQuiet
      }),
      ref: popoverRef,
      placement: "".concat(direction, " ").concat(align),
      shouldFlip: shouldFlip,
      hideArrow: true,
      state: state,
      triggerRef: unwrappedTriggerRef,
      scrollRef: listboxRef
    }, listbox);
  }
  var contents = state.selectedItem ? state.selectedItem.rendered : placeholder;
  if (typeof contents === 'string') contents = /*#__PURE__*/$3toCD$react.createElement($3toCD$Text, null, contents);
  var picker = /*#__PURE__*/$3toCD$react.createElement("div", {
    className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown', {
      'is-invalid': validationState === 'invalid' && !isDisabled,
      'is-disabled': isDisabled,
      'spectrum-Dropdown--quiet': isQuiet
    })
  }, /*#__PURE__*/$3toCD$react.createElement($3toCD$HiddenSelect, {
    autoComplete: autoComplete,
    isDisabled: isDisabled,
    state: state,
    triggerRef: unwrappedTriggerRef,
    label: label,
    name: name
  }), /*#__PURE__*/$3toCD$react.createElement($3toCD$PressResponder, $3toCD$mergeProps(hoverProps, triggerProps), /*#__PURE__*/$3toCD$react.createElement($3toCD$FieldButton, {
    ref: triggerRef,
    isActive: state.isOpen,
    isQuiet: isQuiet,
    isDisabled: isDisabled,
    validationState: validationState,
    autoFocus: autoFocus,
    UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown-trigger', {
      'is-hovered': isHovered
    })
  }, /*#__PURE__*/$3toCD$react.createElement($3toCD$SlotProvider, {
    slots: {
      icon: {
        UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Icon'),
        size: 'S'
      },
      text: _objectSpread(_objectSpread({}, valueProps), {}, {
        UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown-label', {
          'is-placeholder': !state.selectedItem
        })
      }),
      description: {
        isHidden: true
      }
    }
  }, contents), isLoadingInitial && /*#__PURE__*/$3toCD$react.createElement($3toCD$ProgressCircle, {
    isIndeterminate: true,
    size: "S",
    "aria-label": stringFormatter.format('loading'),
    UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown-progressCircle')
  }), validationState === 'invalid' && !isLoadingInitial && !isDisabled && /*#__PURE__*/$3toCD$react.createElement($3toCD$spectrumiconsuiAlertMedium, {
    UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown-invalidIcon')
  }), /*#__PURE__*/$3toCD$react.createElement($3toCD$spectrumiconsuiChevronDownMedium, {
    UNSAFE_className: $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Dropdown-chevron')
  }))), state.collection.size === 0 ? null : overlay);
  var wrapperClassName = label ? $3toCD$classNames( /*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports), 'spectrum-Field', {
    'spectrum-Dropdown-fieldWrapper--quiet': isQuiet,
    'spectrum-Dropdown-fieldWrapper--positionSide': labelPosition === 'side'
  }) : '';
  return /*#__PURE__*/$3toCD$react.createElement($3toCD$Field, _objectSpread(_objectSpread({}, props), {}, {
    ref: domRef,
    wrapperClassName: wrapperClassName,
    labelProps: labelProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    showErrorIcon: false,
    includeNecessityIndicatorInAccessibilityName: true,
    elementType: "span"
  }), picker);
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is limited.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
var $51664a9007a3c6f9$export$ba25329847403e11 = /*#__PURE__*/$3toCD$react.forwardRef($51664a9007a3c6f9$var$Picker);
export { $51664a9007a3c6f9$export$ba25329847403e11 as Picker, $23896c8062ba3967$re_export$Item as Item, $23896c8062ba3967$re_export$Section as Section };